import { createApiRef } from '@backstage/frontend-plugin-api';
import {
  ArgoService,
  Devbox,
  DevboxEvent,
  DevboxProperty,
  DevboxStatus,
  Archetype,
  CreateDevboxRequest,
  Service,
  UpsertServiceRequest,
  ApiKey,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
  UpdateApiKeyRequest,
  DiagnosisResult,
} from './types';

export const devboxManagerApiRef = createApiRef<DevboxManagerApi>().with({
  id: 'plugin.devbox-manager.service',
});

export interface DevboxManagerApi {
  listDevboxes(filters?: {
    name?: string;
    status?: DevboxStatus;
  }): Promise<Devbox[]>;
  getDevbox(name: string): Promise<Devbox>;
  createDevbox(request: CreateDevboxRequest): Promise<Devbox>;
  deleteDevbox(name: string): Promise<Devbox>;
  claimDevbox(name: string): Promise<Devbox>;
  claimDevboxByArchetype(archetype: Archetype): Promise<Devbox>;
  listDevboxEvents(name: string): Promise<DevboxEvent[]>;
  getDevboxProperties(name: string): Promise<DevboxProperty[]>;
  upsertService(
    devboxName: string,
    serviceName: string,
    request: UpsertServiceRequest,
  ): Promise<Service>;
  deleteService(devboxName: string, serviceName: string): Promise<void>;
  listArgoServices(): Promise<ArgoService[]>;
  listApiKeys(): Promise<ApiKey[]>;
  createApiKey(request: CreateApiKeyRequest): Promise<CreateApiKeyResponse>;
  updateApiKey(id: string, request: UpdateApiKeyRequest): Promise<ApiKey>;
  deleteApiKey(id: string): Promise<void>;
  pauseDevbox(name: string): Promise<Devbox>;
  resumeDevbox(name: string): Promise<Devbox>;
  debugDiagnosis(name: string): Promise<DiagnosisResult>;
}
